import React, { useState } from "react";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Label,
    InputGroup,
    InputGroupText,
} from "reactstrap";
import { setSelectedTenant, changeOrganizationAndLoad } from "../../utilities/appStore";
import SwitchHQWarningModal from "../SwitchHQWarningModal/SwitchHQWarningModal";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import "../Shared/TenantSelector.css";
import "./TenantDropdown.css";

const TenantDropdown = ({ tenants }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [pendingSelection, setPendingSelection] = useState(null);

    const toggleDropdown = () => setDropdownOpen((prev) => !prev);
    const toggleModal = () => setModalOpen((prev) => !prev);

    if (!tenants) return null;

    const selectedEntry = Object.values(tenants).find((t) => t.selected);
    const selectedLabel = selectedEntry
        ? `${selectedEntry.name} - ${selectedEntry.accountId}`
        : "Select HQ";

    const handleSelectionClick = (accountId) => {
        if (selectedEntry?.accountId === accountId) return; // No change
        setPendingSelection(accountId);
        setModalOpen(true);
    };

    const confirmSelectionChange = () => {
        if (pendingSelection) {
            setSelectedTenant(pendingSelection);
            changeOrganizationAndLoad(pendingSelection);
        }
        setModalOpen(false);
    };

    return (
        <>
            <div className="d-flex align-items-center gap-2">
                <Label className="mb-0 fw-normal text-white" style={{ minWidth: "110px" }}>
                    HQ Selection:
                </Label>
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                    <DropdownToggle tag="div" className="tenant-dropdown-toggle">
                        <InputGroup className="tenant-input-group">
                            <div className="tenant-input-field">
                                {selectedLabel}
                            </div>
                            <InputGroupText className='tenant-input-icon'>
                                {dropdownOpen ? <ChevronUp color='black' /> : <ChevronDown color='black' />}
                            </InputGroupText>
                        </InputGroup>
                    </DropdownToggle>
                    <DropdownMenu className="hq-menu">
                        {Object.entries(tenants).map(([id, tenant]) => (
                            <DropdownItem
                                key={id}
                                active={tenant.selected}
                                onClick={() => handleSelectionClick(tenant.accountId)}
                            >
                                {tenant.name} - {tenant.accountId}
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                </Dropdown>
            </div>
            <SwitchHQWarningModal
                modalOpen={modalOpen}
                toggleModal={toggleModal}
                confirmSelectionChange={confirmSelectionChange}
            />
        </>
    );
};

export default TenantDropdown;
